module.exports = __webpack_public_path__ + "img/image-thumb-11.3d49c7b0.webp";